/**
 * Polyfills for old browsers.
 *
 * Please remove each polyfill whose market share of browsers needing it drops below 1%
 */

// Array.prototype.find
import 'jspolyfill-array.prototype.find';

// Math.sign (used in SDX ProgressFull)
if (!('sign' in Math)) {
	(Math as any).sign = function(x : number) {
		return (((x > 0) as any) - ((x < 0) as any)) || +x;
	};
}

// Number.isNaN for IE11 and older
// From  https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN#Polyfill
if (!('isNaN' in Number)) {
	(Number as any).isNaN = function(value : any) {
		// NaN is the only value in javascript which is not equal to itself.
		// tslint:disable-next-line: no-tautology-expression
		return value !== value;
	};
}

// String.startsWith for IE11 and friends
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
if(!('startsWith' in String.prototype)) {
	Object.defineProperty(
		String.prototype,
		'startsWith',
		{
			configurable: true,
			value(this : string, search : string, pos? : number) {
				search = String(search);
				const startIndex = (!pos || pos < 0) ? 0 : Number(pos);
				const endIndex = startIndex + search.length;

				return this.substring(startIndex, endIndex) === search;
			},
			writable: true,
		},
	);
}

// Promise/A
import Promise from 'promise-polyfill';
// To add to window
if (!('Promise' in window)) {
	(window as any).Promise = Promise;
}

// URL and URLSearchParams
import 'url-polyfill';

/* Some polyfills are explicitly loaded for certain libraries:
 * etc/designs/portal/clientlibs/shared/js/vendor/smooth-scroll.ts
 * // import 'element-closest';
 * // import 'custom-event-polyfill';
 * // import 'request-animation-frame-polyfill';
*/



// WEBPACK FOOTER //
// typescript://../clientlibs/js/bootstrap/polyfills.ts